module.exports = {
  "subscriptionInteraction": {
    "name": "commerce-billing",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string"
      },
      "buttonType": {
        "type": [
          "BILLING_WIZARD",
          "PAYMENT_LINK"
        ],
        "isOptional": true
      },
      "isEnrolled": {
        "type": "boolean",
        "isOptional": true
      },
      "isActive": {
        "type": "boolean",
        "isOptional": true
      },
      "processorType": {
        "type": [
          "BYO_STRIPE",
          "HS_PAYMENTS",
          "NONE"
        ],
        "isOptional": true
      }
    },
    "namespace": "commerce-billing",
    "version": "1"
  },
  "interactionEvent": {
    "namespace": "BILLING_WIZARD",
    "name": "user-interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string"
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "isEnrolled": {
        "type": "boolean",
        "isOptional": true
      },
      "isActive": {
        "type": "boolean",
        "isOptional": true
      },
      "processorType": {
        "type": [
          "BYO_STRIPE",
          "HS_PAYMENTS",
          "NONE"
        ],
        "isOptional": true
      }
    },
    "version": "1"
  },
  "userSession": {
    "namespace": "BILLING_WIZARD",
    "name": "BILLING_WIZARD",
    "class": "usage",
    "properties": {
      "fromObjectTypeId": {
        "type": "string",
        "isOptional": true
      },
      "isActive": {
        "type": "boolean",
        "isOptional": true
      },
      "origin": {
        "type": "string"
      },
      "paymentType": {
        "type": "string"
      },
      "timeOnPage": {
        "type": "number"
      },
      "type": {
        "type": [
          "SUBMIT",
          "CHURN"
        ]
      },
      "subType": {
        "type": [
          "SUCCESS",
          "UNKNOWN",
          "MANUAL_EXIT",
          "NAVIGATE_AWAY"
        ]
      },
      "changedOnboardingFromAddress": {
        "type": "boolean"
      },
      "numLineItems": {
        "type": "number"
      },
      "numRecurringLineItems": {
        "type": "number"
      },
      "numOneTimeLineItems": {
        "type": "number"
      },
      "numLineItemsWithTax": {
        "type": "number"
      },
      "discountsApplied": {
        "type": "boolean"
      },
      "numProductLineItems": {
        "type": "number"
      },
      "numCustomLineItems": {
        "type": "number"
      },
      "numDealLineItems": {
        "type": "number"
      },
      "billingFrequency": {
        "type": "array"
      },
      "numPayments": {
        "type": "array",
        "isOptional": true
      },
      "checkoutType": {
        "type": "string"
      },
      "paymentMethods": {
        "type": "array"
      },
      "errors": {
        "type": "array"
      },
      "currencyCode": {
        "type": "string",
        "isOptional": true
      },
      "isEnrolled": {
        "type": "boolean"
      },
      "createdObjects": {
        "type": "array"
      },
      "updatedObjects": {
        "type": "array"
      },
      "initial": {
        "type": "array"
      },
      "collectShippingAddress": {
        "type": "boolean"
      },
      "collectFullBillingAddress": {
        "type": "boolean"
      },
      "hasComment": {
        "type": "boolean"
      },
      "language": {
        "type": "string"
      },
      "locale": {
        "type": "string"
      },
      "onboardingKey": {
        "type": "string"
      },
      "invoiceNetDueDays": {
        "type": "string"
      },
      "chargesEnabled": {
        "type": "boolean"
      },
      "emailSent": {
        "type": "boolean"
      },
      "paymentMethod": {
        "type": "string"
      },
      "existingPaymentMethod": {
        "type": "string",
        "isOptional": true
      },
      "processorType": {
        "type": [
          "BYO_STRIPE",
          "HS_PAYMENTS",
          "NONE"
        ],
        "isOptional": true
      }
    },
    "version": "1"
  }
};